<div class="content">
  <form class="search-form" [formGroup]="frm">
    <div class="btn-search">
      <div class="input-search">     
          <input class="input"  type="text" formControlName="searchKey" matInput>
      </div>
      <div class="button">
        <button mat-raised-button (click)="busquedaCategoriaSistema()">
          <span class="txtBuscar">BUSCAR</span>
        </button>
      </div>
    </div>
</form>    
  <menu-categorias [categorias]="categorias" (onSelected)="onSelectedProduct($event)"></menu-categorias>
</div>